import Vue from 'vue';
import VueUnleash from 'vue-unleash';
import Vuex from 'vuex';
import Auth from './auth';
import Person from './person';
import Subscription from './subscription';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Auth,
    Person,
    Subscription,
  },
});

Vue.use(VueUnleash, {
  appName: 'account',
  host: process.env.VUE_APP_UNLEASH_URL,
  store,
});

export default store;
